import React, { useContext } from "react";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { BASE_URL } from "../../../constant";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { typeData, intervalData, unitData, simType } from "../../../constant";
import Mapping from "./Mapping";
import Transforming from "./Transforming";
import { confirmAlert } from "react-confirm-alert";
import AlarmSettings from "../alarm/AlarmSettings";
import BtnLoader from "../../BtnLoader";
import AppContext from "../../../AppContext";
import { useTranslation } from "react-i18next";
import { AlarmInfo, AlarmLimit } from "../common/AlarmView";
import { ReactSVG } from "react-svg";

const DefaultSensorDetails = ({
  index,
  id,
  findSensorData,
  setMappingPopup,
  setTransformPopup,
  setDevice,
  setAlarmPopup,
  alarms,
  onEditAlarm,
  onAlarmDelete,
  t,
  darkMode,
}) => {
  // const [sensorData, setSensorData] = useState(sensorData);
  const handleChange = (e, i) => {
    setDevice((pre) => ({
      ...pre,
      sensors: pre.sensors.map((s, index) =>
        index === i && s.default ? { ...s, [e.target.name]: e.target.value } : s
      ),
    }));
  };
  return (
    <div className="flex flex-col gap-1 mb-2 -mt-3 text-xs font-medium">
      <div className="flex gap-4">
        <div className="flex flex-col w-40 lg:w-52">
          <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
            {t("masters.fields.sensorId")}
            <span className=" text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            name="sensorId"
            placeholder="Sensor Id"
            value={findSensorData(id)?.sensorId}
            // disabled={true}
            onChange={(e) => handleChange(e, index)}
            className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 h-9"
          />
        </div>
        <div className="flex flex-col w-40 lg:w-52">
          <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
            {t("masters.fields.name")}
            <span className=" text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            name="name"
            placeholder="Name"
            // disabled={true}
            value={findSensorData(id)?.name}
            onChange={(e) => handleChange(e, index)}
            className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 h-9"
          />
        </div>
        <div className="flex flex-col w-40 lg:w-52" id="compo4">
          <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
            {t("masters.fields.type")}
            <span className=" text-red-600 ml-1">*</span>
          </label>
          <div className={`${darkMode ? "darkCombo" : "lightCombo"}`}>
            <ComboBox
              data={typeData}
              name="type"
              suggest={true}
              style={{ fontSize: "12px", fontWeight: "500" }}
              clearButton={false}
              className=" block border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 h-9"
              onChange={(e) => handleChange(e, index)}
              value={findSensorData(id)?.type}
            />
          </div>
        </div>
        {id !== "GSM" &&
          id !== "GNSS" &&
          id !== "WIFI" &&
          id !== "Device Status" && (
            <div className="flex flex-col w-40 lg:w-52" id="compo4">
              <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
                {t("masters.fields.unit")}
                <span className=" text-red-600 ml-1">*</span>
              </label>
              <div className={`${darkMode ? "darkCombo" : "lightCombo"}`}>
                <ComboBox
                  data={unitData}
                  name="unit"
                  suggest={true}
                  style={{ fontSize: "12px", fontWeight: "500" }}
                  clearButton={false}
                  className=" block border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 h-9"
                  onChange={(e) => handleChange(e, index)}
                  value={findSensorData(id)?.unit}
                />
              </div>
            </div>
          )}
        <div className="flex flex-col w-40 lg:w-52">
          <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
            {t("masters.fields.desc")}
            <span className=" text-red-600 ml-1">*</span>
          </label>
          <input
            type="text"
            name="description"
            placeholder="Description"
            // disabled={true}
            value={findSensorData(id)?.description}
            onChange={(e) => handleChange(e, index)}
            className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 h-9"
          />
        </div>
        <div className="flex flex-col h-full">
          <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
            {t("button.mapping")}
          </label>
          <button
            type="button"
            className={`flex flex-col h-9 gap-1 ${
              findSensorData(id)?.mappings !== null &&
              findSensorData(id)?.mappings.data &&
              findSensorData(id)?.mappings.data.length !== 0
                ? "bg-green-500"
                : "dark:bg-neutral-800 bg-zinc-600"
            } justify-center items-center rounded-lg`}
            onClick={() => {
              // setSelectedSensorIndex(index);
              setMappingPopup(index);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
              />
            </svg>
          </button>
        </div>
        {findSensorData(id)?.type === "Number" && (
          <>
            <div className="flex flex-col h-full pb-0">
              <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
                {t("button.transform")}
              </label>
              <button
                type="button"
                className={` ${
                  findSensorData(id)?.transforms !== null &&
                  findSensorData(id)?.transforms.operation !== "" &&
                  findSensorData(id)?.transforms.example !== "" &&
                  findSensorData(id)?.transforms.value !== ""
                    ? "bg-green-500"
                    : "dark:bg-neutral-800 bg-zinc-600"
                } flex flex-col h-9 gap-1 bg-neutral-800 justify-center items-center rounded-lg`}
                onClick={() => {
                  // setSelectedSensorIndex(index);
                  setTransformPopup(index);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"
                  />
                </svg>
              </button>
            </div>
          </>
        )}
        <button
          button="button"
          className=" dark:bg-neutral-800 bg-zinc-600 w-40 h-9 mt-11 rounded-md disabled:opacity-40"
          onClick={(e) => setAlarmPopup(findSensorData(id))}
          disabled={alarms?.find(
            (x) => x.parameterId === findSensorData(id).id
          )}
        >
          <div className="flex justify-center items-center rounded-lg gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="grey"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>
            <label className="text-xs lg:text-sm font-medium">
              {/* {item.alarm ? "Edit Alarm" : "Add Alarm"} */}
              {t("button.addAlrm")}
            </label>
          </div>
        </button>
      </div>
      {alarms &&
        alarms.length > 0 &&
        alarms.some((a) => a.parameterId === findSensorData(id).id) && (
          <div className="flex gap-36">
            <label className="text-white font-medium text-xs lg:text-sm py-1">
              {t("alarms.headerText")}
            </label>
          </div>
        )}
      {alarms &&
        alarms.map(
          (i, index) =>
            i.parameterId === findSensorData(id).id && (
              <div className="flex flex-col py-1" key={index}>
                <div class=" dark:bg-neutral-800 bg-zinc-500  rounded-lg w-11/12 lg:w-fit h-fit px-3 py-2">
                  <div className="flex gap-6 ml-1 pt-2">
                    <div className="flex flex-col gap-3 text-xs lg:text-sm py-1 w-40 pr-3 border-r-2 border-zinc-700">
                      <div className="flex w-24">
                        <label className="text-white text-xs lg:text-sm font-medium">
                          {t("masters.fields.alrmName")}
                        </label>
                      </div>
                      <div className="flex w-36">
                        <label>{i.alarmName}</label>
                      </div>
                    </div>
                    {/* Alarm Info */}
                    {i.infoEnabled === true &&
                      (i.parameterType === "String" ||
                      i.parameterType === "Boolean" ? (
                        <AlarmInfo
                          label={t("masters.fields.info")}
                          value={i.infoSensorValue}
                          text={i.infoAlarmText}
                          t={t}
                        />
                      ) : i.parameterType === "Number" ? (
                        <AlarmLimit
                          label={t("masters.fields.info")}
                          min={i.infoLowerLimit}
                          max={i.infoUpperLimit}
                          t={t}
                        />
                      ) : null)}

                    {/* Warning Info */}
                    {i.warningEnabled === true &&
                      (i.parameterType === "String" ||
                      i.parameterType === "Boolean" ? (
                        <AlarmInfo
                          label={t("masters.fields.warning")}
                          value={i.warningSensorValue}
                          text={i.warningAlarmText}
                          t={t}
                        />
                      ) : i.parameterType === "Number" ? (
                        <AlarmLimit
                          label={t("masters.fields.warning")}
                          min={i.warningLowerLimit}
                          max={i.warningUpperLimit}
                          t={t}
                        />
                      ) : null)}

                    {/* Critical Info */}
                    {i.criticalEnabled === true &&
                      (i.parameterType === "String" ||
                      i.parameterType === "Boolean" ? (
                        <AlarmInfo
                          label={t("masters.fields.critical")}
                          value={i.criticalSensorValue}
                          text={i.criticalAlarmText}
                          t={t}
                        />
                      ) : i.parameterType === "Number" ? (
                        <AlarmLimit
                          label={t("masters.fields.critical")}
                          min={i.criticalLowerLimit}
                          max={i.criticalUpperLimit}
                          t={t}
                        />
                      ) : null)}

                    {/* Edit Button */}
                    <div className="flex justify-center items-center">
                      <div className="flex h-10 w-9 mr-2 dark:bg-neutral-900 bg-zinc-800 justify-center items-center rounded-lg">
                        <button
                          type="button"
                          onClick={(e) => onAlarmDelete(e, index)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-4"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                            />
                          </svg>
                        </button>
                      </div>
                      <div className="flex h-10 w-9 mr-2 dark:bg-neutral-900 bg-zinc-800 justify-center items-center rounded-lg">
                        <button
                          type="button"
                          onClick={(e) =>
                            onEditAlarm(e, findSensorData(id), index, i)
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-4 h-4"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
        )}
    </div>
  );
};
const ControllerForm = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { authCtx, darkMode } = useContext(AppContext);
  const defaultStanderedSensor = {
    id: "",
    sensorId: "",
    name: "",
    type: "Number",
    unit: "",
    mappings: null,
    transforms: null,
    description: "",
    default: true,
  };

  const defaultform = {
    label: "",
    manufacturer: "",
    active: true,
    simType: "Single",
    defaultSensors: [],
    sensors: [
      {
        id: "0",
        sensorId: "",
        name: "",
        type: "Number",
        unit: "",
        description: "",
        mappings: null,
        transforms: null,
        default: false,
      },
    ],
    alarms: [],
  };
  const [device, setDevice] = useState(defaultform);
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);

  const onValueChange = (e) => {
    setDevice({ ...device, [e.target.name]: e.target.value });
  };

  const handleIntervalChange = (event) => {
    setDevice({
      ...device,
      interval: event.value,
    });
  };

  const handlePropertyTypeChange = (event, id) => {
    setDevice({
      ...device,
      sensors: device.sensors.map((d, index) =>
        index === id ? { ...d, type: event.value } : d
      ),
    });
  };

  const handlePropertyUnitChange = (event, id) => {
    setDevice({
      ...device,
      sensors: device.sensors.map((d, index) =>
        index === id ? { ...d, unit: event.value } : d
      ),
    });
  };

  const addProperty = (e) => {
    setDevice({
      ...device,
      sensors: [...device.sensors, defaultform.sensors[0]],
    });
  };

  const onDelete = (id) => {
    if (device.sensors.length > 1) {
      setDevice({
        ...device,
        sensors: device.sensors.filter((i, index) => {
          return index !== id;
        }),
      });
    }
  };

  const onMappingPopup = (index) => {
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <Mapping
            device={device}
            setDevice={setDevice}
            selectedSensorIndex={index}
            setOpen={onClose}
          />
        );
      },
    });
  };

  const onTransformPopup = (index) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Transforming
            device={device}
            setDevice={setDevice}
            selectedSensorIndex={index}
            setOpen={onClose}
          />
        );
      },
    });
  };

  const onAlarmPopup = (item, selectedalarm) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AlarmSettings
            setAlarmPopup={onClose}
            setState={setDevice}
            selectedParameter={{ ...item, alarmParentId: item.id }}
            alarmPopup={true}
            selectedAlarm={selectedalarm}
          />
        );
      },
    });
  };

  const onAlarmDelete = (e, id) => {
    setDevice((pre) => ({
      ...pre,
      alarms: pre.alarms.filter((_, index) => index !== id),
    }));
  };
  const onAddAlarm = (item) => {
    onAlarmPopup(item, null);
  };

  const onEditAlarm = (e, item, index, alarm) => {
    const selectedItem = { ...item, alarmParentId: item.parameterId };
    const selectedalarm = { ...alarm, index: index };
    onAlarmPopup(selectedItem, selectedalarm);
  };

  const onActiveChange = () => {
    setDevice((pre) => ({ ...pre, active: !pre.active }));
  };

  const onCompanyCheck = (e) => {
    setDevice((pre) => ({
      ...pre,
      companyAssign: e.target.checked,
      company: !e.target.checked ? null : pre.company,
      companyId: !e.target.checked ? null : pre.companyId,
    }));
  };

  const onCheckBox = (e, defaultSensor) => {
    const checked = e.target.checked;
    let updatedSensors;
    if (checked) {
      updatedSensors = [
        ...device.sensors,
        {
          ...defaultStanderedSensor,
          id: defaultSensor.name,
          name: defaultSensor.sensorName,
          section: defaultSensor.section,
          description: defaultSensor.sensorName,
        },
      ];
    } else {
      updatedSensors = [
        ...device.sensors.filter((s) => s.id !== defaultSensor.name),
      ];
    }
    setDevice({
      ...device,
      defaultSensors: device.defaultSensors.map((ds) =>
        e.target.name === ds.name ? { ...ds, enabled: !ds.enabled } : ds
      ),
      sensors: updatedSensors,
      alarms: device.alarms.filter((x) =>
        updatedSensors.some((us) => us.id === x.parameterId)
      ),
    });
  };

  const onCloseClick = (e) => {
    navigate(`/controllerlist`);
  };

  const validateSensorsIds = async () => {
    const sensorIds = new Set();
    for (let i = 0; i < device.sensors.length; i++) {
      const sensorId = device.sensors[i].sensorId;
      if (sensorIds.has(sensorId)) {
        return true;
      }
      sensorIds.add(sensorId);
    }
    return false;
  };

  const onSubmit = async (e) => {
    const notValidate = await validateSensorsIds();
    if (notValidate) toast.error("Sensor Id must be unique");
    else {
      setLoading(true);
      try {
        const res = await axios.post(`${BASE_URL}/DeviceType/PostData`, device);
        if (!device.id) {
          setDevice({ ...device, id: res.data });
          navigate(`/controllerform/${res.data}`);
        }
        toast.success("Successfully added new Device Type");
        setLoading(false);
      } catch (err) {
        if (err.response?.status === 400) toast.error(err.response.data);
        else toast.error("An error occured");
        setLoading(false);
      }
    }
  };

  const handlePropertyChange = (event, id) => {
    let value = event.target.value;
    const data = {
      ...device,
      sensors: device.sensors.map((d, index) =>
        index === id ? { ...d, [event.target.name]: value } : d
      ),
    };
    setDevice(data);
  };

  const loadData = async () => {
    let res = await axios.get(`${BASE_URL}/DeviceType/${id}`);
    const data = res.data;
    const optionDatas = {
      ...data,
      intervalData: intervalData.find((i) => i.id === data.interval),
      // company: companyData.find((x) => x.id === data.companyId),
      sensors: data.sensors.map((p) => ({
        ...p,
        typeData: typeData.find((i) => i.id === p.type),
        unitData: unitData.find((i) => i.value === p.unit),
      })),
    };
    setDevice(optionDatas);
  };

  const loadDeviceTypeStandardSensors = async () => {
    let res = await axios.get(`${BASE_URL}/DeviceStandardSensor/Getall`);
    const data = res.data;
    if (data.length > 0) {
      const deviceData = {
        ...device,
        defaultSensors: data.map((d) => ({
          name: d.name,
          sensorName: d.sensorName,
          enabled: false,
          section: d.section,
          additionalValues: d.additionalValues,
        })),
      };
      setDevice(deviceData);
    }
  };

  const findConnectivityValues = (i) => {
    const res = device.sensors.find((p) => p.id === i && p.default);
    return res;
  };

  const findConnectivityValueIndex = (i) => {
    const index = device.sensors.findIndex((p) => p.id === i && p.default);
    return index;
  };

  // const handleCompanyChange = (e) => {
  //   setDevice((pre) => ({ ...pre, company: e.value, companyId: e.value.id }));
  // };

  const loadLookupData = async () => {
    let res = await axios.get(`${BASE_URL}/api/CompanyMaster`);
    if (res.status === 200) {
      const data = res.data;
      setCompanies(data);
      return data;
    }
  };

  useEffect(() => {
    const loadDatas = async () => {
      // const companyData = await loadLookupData();
      if (id !== "new") {
        loadData();
      } else {
        // setDevice((pre) => ({
        //   ...pre,
        //   companyId: authCtx.profile.companyId,
        //   company: companyData.find((x) => x.id === authCtx.profile.companyId),
        // }));
        loadDeviceTypeStandardSensors();
      }
    };
    loadDatas();
  }, []);

  return (
    <div className="flex flex-col relative text-white px-12 py-7 dark:bg-darkModeBg bg-lightModeBg h-full w-full overflow-x-hidden">
      <div className="flex justify-between w-full">
        <div className="flex text-sm font-medium gap-3 items-center">
          <button type="button" onClick={onCloseClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2.0"
              stroke={darkMode ? "white" : "black"}
              className="w-7 h-7"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          </button>
          <label className="text-xs lg:text-2xl dark:text-white text-labels">
            {t("masters.headerTexts.deviceTemplate")}
          </label>
          <div className="flex h-10 w-10  dark:bg-neutral-800 bg-gray2 justify-center items-center rounded-full">
            <ReactSVG
              src="ControllerSettingIcon.svg"
              className="w-4 h-3 flex items-center justify-center"
              beforeInjection={(svg) => {
                svg.setAttribute(
                  "style",
                  `fill: ${darkMode ? "white" : "black"}`
                );
              }}
            />
            {/* <img
              src="ControllerSettingIcon.svg"
              alt="ControllerSettingIcon"
              className=" w-4 h-3 hover:fill-white"
            /> */}
          </div>
        </div>
      </div>
      <div className="flex flex-col w-fit">
        <div className="flex flex-row text-xs font-medium pt-4 gap-3">
          <div className="flex flex-col">
            <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
              {t("masters.fields.name")}
              <span className=" text-red-600 ml-1">*</span>
            </label>
            <input
              type="text"
              maxlength="50"
              name="label"
              value={device.label}
              disabled={id !== "new"}
              onChange={onValueChange}
              placeholder="Name"
              className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-80 h-9"
            />
          </div>
          <div className="flex flex-col ml-1">
            <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
              {t("masters.fields.manufacturer")}
            </label>
            <input
              type="text"
              name="manufacturer"
              value={device.manufacturer}
              onChange={onValueChange}
              placeholder="Enter Description"
              className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 w-40 lg:w-80 h-9"
            />
          </div>
          <div className="flex flex-col ml-1" id="compo2">
            <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
              {t("masters.fields.detailInterval")}
            </label>
            <div className="interval-input-container w-40 lg:w-80">
              {/* <input
                type="number"
                placeholder="Interval"
                name="interval"
                className="block border-grey-light text-white rounded-lg dark:bg-zinc-750 bg-gray2 mb-4 w-[20rem] lg:w-[40rem] h-9 mt-3"
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  paddingLeft: "16px",
                  WebkitAppearance: "none",
                }}
                onChange={onValueChange}
                value={device?.interval}
              /> */}
              <input
                type="number"
                placeholder="Interval"
                name="interval"
                className="block border-grey-light dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts dark:text-white text-inputFieldsTxts rounded-lg dark:bg-zinc-750 bg-inputFields mb-4 w-40 lg:w-80 h-9"
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  paddingLeft: "16px",
                  WebkitAppearance: "none",
                }}
                onChange={onValueChange}
                value={device?.interval}
              />
            </div>
          </div>
        </div>
        <div className="text-base lg:text-lg font-medium gap-3 items-center py-2 dark:text-white text-labels">
          {t("masters.headerTexts.dsSensors")}
        </div>
        {device.defaultSensors &&
          device.defaultSensors.map((ds, index) => (
            <>
              <div className="flex gap-5 my-3">
                <div className="flex ml-0 items-center w-32 justify-between">
                  <label className="dark:text-white text-labels text-xs lg:text-sm font-medium">
                    {ds.name}
                  </label>
                  <input
                    type="checkbox"
                    name={ds.name}
                    placeholder="Enter Description"
                    className="focus:ring-blue-500 h-4 lg:h-4 w-3 lg:w-4 text-blue-600 border-gray-300 rounded"
                    onChange={(e) => onCheckBox(e, ds)}
                    checked={ds.enabled}
                    value={ds.enabled}
                  />
                </div>
                {ds.enabled &&
                  ds.additionalValues.length > 0 &&
                  ds.additionalValues[0].name === "simType" && (
                    <div
                      className="flex justify-end items-center"
                      id="propTypecombo"
                    >
                      <label className=" placeholder:text-white rounded-lg dark:text-white text-black">
                        <div
                          className={`inline-flex rounded-xl group h-7 border-2 bg-lime-700 border-lime-800`}
                        >
                          {simType.map((st) => (
                            <button
                              type="button"
                              key={st.id}
                              className={`text-xs font-medium text-center rounded-xl text-white w-1/2 px-2 ${
                                ds.additionalValues[0].value == st.value
                                  ? " bg-lime-700"
                                  : "bg-white opacity-75"
                              }`}
                              onClick={() => {
                                setDevice((pre) => ({
                                  ...pre,
                                  defaultSensors: pre.defaultSensors.map(
                                    (dfs, i) =>
                                      index === i
                                        ? {
                                            ...dfs,
                                            additionalValues: [
                                              {
                                                ...dfs.additionalValues[0],
                                                value: st.value,
                                              },
                                            ],
                                          }
                                        : dfs
                                  ),
                                }));
                              }}
                            >
                              {st.value}
                            </button>
                          ))}
                        </div>
                      </label>
                    </div>
                  )}
              </div>
              {ds.enabled && (
                <DefaultSensorDetails
                  index={findConnectivityValueIndex(ds.name)}
                  id={ds.name}
                  findSensorData={findConnectivityValues}
                  setDevice={setDevice}
                  setMappingPopup={onMappingPopup}
                  // setSelectedSensorIndex={setSelectedSensorIndex}
                  setTransformPopup={onTransformPopup}
                  setAlarmPopup={onAddAlarm}
                  alarms={device.alarms}
                  onEditAlarm={onEditAlarm}
                  onAlarmDelete={onAlarmDelete}
                  t={t}
                  darkMode={darkMode}
                />
              )}
            </>
          ))}
        <div className="flex text-base lg:text-lg font-medium gap-3 pt-5 items-center justify-between">
          <label className="dark:text-white text-labels">
            {" "}
            {t("masters.headerTexts.sensors")}
          </label>
        </div>
        <div className="flex h-fit gap-4 pb-4">
          <div className="flex flex-col text-xs font-medium py-2 w-fit">
            {device.sensors.map(
              (item, index) =>
                !item.default && (
                  <div className="flex gap-4" id={index}>
                    <div className="flex flex-col gap-1 w-40 lg:w-52">
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
                        {t("masters.fields.sensorId")}
                        <span className=" text-red-600 ml-1">*</span>
                      </label>
                      <input
                        type="text"
                        name="sensorId"
                        placeholder="Sensor Id"
                        value={item.sensorId}
                        // disabled={item.id !== "0"}
                        onChange={(e) => handlePropertyChange(e, index)}
                        className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 h-9"
                      />
                    </div>
                    <div className="flex flex-col gap-1 w-40 lg:w-52">
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
                        {t("masters.fields.name")}
                        <span className=" text-red-600 ml-1">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={item.name}
                        onChange={(e) => handlePropertyChange(e, index)}
                        className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 h-9"
                      />
                    </div>
                    <div
                      className="flex flex-col gap-1  w-40 lg:w-52"
                      id="compo4"
                    >
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
                        {t("masters.fields.type")}
                        <span className=" text-red-600 ml-1">*</span>
                      </label>
                      <div
                        className={` ${darkMode ? "darkCombo" : "lightCombo"}`}
                      >
                        <ComboBox
                          data={typeData}
                          // dataItemKey="id"
                          // textField="value"
                          defaultValue="String"
                          name="type"
                          suggest={true}
                          style={{ fontSize: "12px", fontWeight: "500" }}
                          clearButton={false}
                          className=" block border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 h-9"
                          onChange={(e) => handlePropertyTypeChange(e, index)}
                          value={item.type}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-1  w-14 lg:w-24">
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
                        {t("masters.fields.unit")}
                      </label>
                      <div
                        className={` ${darkMode ? "darkCombo" : "lightCombo"}`}
                      >
                        <ComboBox
                          data={unitData}
                          // dataItemKey="id"
                          // textField="value"
                          name="unit"
                          suggest={true}
                          clearButton={false}
                          style={{ fontSize: "12px", fontWeight: "500" }}
                          className="block border-grey-light dark:text-white text-inputFieldsTxts rounded-lg mb-4 h-9"
                          onChange={(e) => handlePropertyUnitChange(e, index)}
                          value={item.unit}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-1 w-40 lg:w-80">
                      <label className="dark:text-white text-labels text-xs lg:text-sm font-medium py-3">
                        {t("masters.fields.desc")}
                        <span className=" text-red-600 ml-1">*</span>
                      </label>
                      <input
                        type="text"
                        maxLength="200"
                        name="description"
                        placeholder="Description"
                        value={item.description}
                        onChange={(e) => handlePropertyChange(e, index)}
                        className="block dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts border-grey-light rounded-lg mb-4 dark:bg-zinc-750 bg-inputFields dark:text-white text-inputFieldsTxts px-5 h-9"
                      />
                    </div>
                    <div className="flex flex-col h-full">
                      <label className="dark:text-white text-inputPlaceHolderTxts text-xs lg:text-sm font-medium py-3">
                        {t("button.mapping")}
                      </label>
                      <button
                        type="button"
                        className={`flex flex-col h-9 gap-1 ${
                          item?.mappings !== null &&
                          item.mappings.data &&
                          item.mappings.data.length !== 0
                            ? "bg-green-500"
                            : "dark:bg-neutral-800 bg-zinc-600"
                        } justify-center items-center rounded-lg`}
                        onClick={() => {
                          // setSelectedSensorIndex(index);
                          onMappingPopup(index);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-4 h-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
                          />
                        </svg>
                      </button>
                    </div>
                    {item?.type === "Number" && (
                      <div className="flex flex-col h-full pb-0">
                        <label className="dark:text-white text-black text-xs lg:text-sm font-medium py-3">
                          {t("button.transform")}
                        </label>
                        <button
                          type="button"
                          className={`${
                            item?.transforms !== null &&
                            item?.transforms.operation !== "" &&
                            item?.transforms.example !== "" &&
                            item?.transforms.value !== ""
                              ? "bg-green-500"
                              : "dark:bg-neutral-800 bg-zinc-600"
                          } flex flex-col h-9 gap-1 bg-neutral-800 justify-center items-center rounded-lg`}
                          onClick={() => {
                            // setSelectedSensorIndex(index);
                            onTransformPopup(index);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="w-5 h-5"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                    <div className="flex flex-col gap-1 mt-11">
                      <div className="flex gap-5">
                        <div className="flex h-9 w-9  dark:bg-neutral-800 bg-zinc-600 justify-center items-center rounded-lg">
                          <button
                            type="button"
                            onClick={(e) => onDelete(index)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="w-4 h-4"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )
            )}
          </div>
          <div className="flex flex-col justify-end text-xs font-medium py-2 w-fit">
            <button
              button="button"
              onClick={(e) => addProperty(e)}
              className="dark:bg-neutral-800 bg-zinc-600 w-fit px-4 h-9 mb-5 rounded-md"
            >
              <div className="flex justify-center items-center rounded-lg gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="grey"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                  />
                </svg>
                <label className="text-xs lg:text-sm font-medium truncate w-fit dark:text-white text-white">
                  {t("button.newSensor")}
                </label>
              </div>
            </button>
          </div>
        </div>
        <div className="flex items-center mt-7 gap-3 fixed bottom-0 py-2 dark:bg-neutral-900 bg-white w-full left-8 justify-center z-10">
          <div className="flex justify-center form-check form-check-inline mr-2">
            <label
              className="form-check-label inline-block text-xs lg:text-sm dark:text-white text-labels mr-3 mt-1"
              forhtml="inlineCheckbox1"
            >
              {t("masters.fields.active")}
            </label>
            <input
              name="active"
              type="checkbox"
              className="focus:ring-blue-500 h-4 lg:h-5 w-4 lg:w-5 text-blue-600 border-gray-300 rounded mt-1"
              id="inlineCheckbox1"
              onChange={onActiveChange}
              checked={device.active}
              value={device.active}
            ></input>
          </div>
          <button
            type="button"
            name="create"
            onClick={onCloseClick}
            className=" dark:bg-white bg-closeBtns dark:text-black text-closeBtnTxts text-xs lg:text-sm rounded-4xl px-10 lg:w-48 h-10"
          >
            {t("button.cancel")}
          </button>
          <button
            type="button"
            name="create"
            onClick={onSubmit}
            disabled={
              loading ||
              device.label === "" ||
              device.sensors.some(
                (dp) =>
                  !dp.default &&
                  (dp.description === "" ||
                    dp.sensorId === "" ||
                    dp.name === "")
              )
            }
            className="dark:bg-indigo-700 bg-submitBtns dark:text-white text-submitBtnTxts text-xs lg:text-sm rounded-4xl px-10 lg:w-48 h-10 disabled:opacity-60 flex items-center justify-center gap-3"
          >
            {loading.formLoading && <BtnLoader />}
            {device.id ? t("button.update") : t("button.create")}
          </button>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
};

export default ControllerForm;
